import { Square, FileCode2, Table as TableIcon, Eye, Server, Network, Terminal } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import type { SearchItem, SearchProvider } from '../types';
import type { WorkareaTab } from '@/types';

const TAB_ICON: Partial<Record<WorkareaTab['type'], LucideIcon>> = {
  table: TableIcon,
  info: Server,
  query: FileCode2,
  tunnel: Network,
  structure: TableIcon,
  terminal: Terminal,
  designer: TableIcon,
  'code-editor': Eye,
};

function tabLabel(t: WorkareaTab): string {
  switch (t.type) {
    case 'table':
    case 'structure':
      return `${t.schema}.${t.table}`;
    case 'info':
      return t.objectName;
    case 'query':
      return t.title || 'Query';
    case 'tunnel':
      return t.tunnelName;
    case 'terminal':
      return (t as { title?: string }).title ?? 'Terminal';
    case 'designer':
      return `Designer: ${t.schema}${t.tableName ? '.' + t.tableName : ''}`;
    case 'code-editor':
      return `${t.objectType}: ${t.objectName}`;
    default:
      return t.id;
  }
}

/**
 * Currently open tabs. Picking one focuses it — useful when you have more
 * tabs than the tab bar can comfortably show.
 */
export const tabSearchProvider: SearchProvider = {
  id: 'tabs',
  kind: 'tab',
  list: () => {
    const tabs = useWorkspaceStore.getState().tabs;
    return tabs.map<SearchItem>((t) => ({
      id: `tab:${t.id}`,
      kind: 'tab',
      label: tabLabel(t),
      subtitle: `Open tab · ${t.type}`,
      icon: TAB_ICON[t.type] ?? Square,
      boost: 1.1,
      action: () => useWorkspaceStore.getState().switchTab(t.id),
    }));
  },
};
